<template>
    <div class="menu-second">
        <div class="menu-second">
            <div class="menu-title">
                <span>满减</span>
            </div>
            <div class="menu-list">
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/manjian/list.html'}">满减列表</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "left"
    }
</script>

<style scoped>

</style>
